import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Row, Col } from "react-bootstrap";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const SchoolTrends = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [SCPTrends, SetSCPTrends] = useState();
  const [SelectSchool, SetSelectSchool] = useState();

  const SchoolPerformanceTrends = async (School) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetSchoolPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&SchoolId=${School}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetSCPTrends(res.data);
          SetSelectSchool(School);
        } else {
          SetSCPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const SocietySchoolPerformanceTrends = async (School) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetSocietySchoolPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&SchoolId=${School}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetSCPTrends(res.data);
          SetSelectSchool(School);
        } else {
          SetSCPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubSelect && items?.societyId) {
      SocietySchoolPerformanceTrends(
        SelectSchool || props.SchoolIds?.[0].value
      );
    } else {
      SchoolPerformanceTrends(SelectSchool || props.SchoolIds?.[0].value);
    }
  }, [SelectSchool, props.AType, props.SchoolIds, USYear]);
  const labels = [];
  const Subjects = {};

  if (SCPTrends?.[0].assessmentDate) {
    SCPTrends?.forEach((item) => {
      if (
        !labels.includes(item.assessmentDate) &&
        props.SubSelect === item.subjectName
      ) {
        labels.push(item.assessmentDate);
      }
      if (!Subjects[item.subjectName]) {
        Subjects[item.subjectName] = [];
      }
    });
    SCPTrends?.forEach((item) => {
      Subjects[item.subjectName].push(item.percentage);
    });
  }

  const datasets = Object.keys(Subjects).map((Subject) => ({
    label: Subject,
    data: Subjects[props.SubSelect],
    backgroundColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    borderColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    // #3B9ED7 - P & C
    // #F7C66A - b
    // #A63D95 - bt
    maxBarThickness: 40,
    barThickness: 45,
  }));

  // datasets.push({
  //   label: 'Regional',
  //   data: DPTrends, // Static data here
  //   backgroundColor: '#FF6384', // Set your desired color
  //   borderColor: '#FF6384',
  //   fill: false,
  //   maxBarThickness: 40,
  //   barThickness: 45,
  // });
  const data = { labels: labels, datasets: datasets };
  const options = {
    aspectRatio: 2,
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === props.SubSelect) {
              const label = context.dataset.label || "";
              const value =
                context.parsed.y !== null ? context.parsed.y + "%" : "";
              return `${label}: ${value}`;
            }
            return null;
          },
        },
      },
    },
    scales: {
      x: {
        offset: 20,
        grid: { display: false },
        title: { display: true, text: "Assessment Date" },
      },
      y: {
        title: { display: true, text: "Performance %" },
        beginAtZero: true,
        max: 100,
      },
    },
  };

  const ChangeSchool = (e) => {
    SetSelectSchool(e);
  };
  return (
    <>
      <div className="dflex JSBetween mb-2">
        <div className="SubHeading">Schoolwise performance</div>
        <div>
          {props.SchoolIds && (
            <DropdownValues
              className="NCLDropdown"
              options={props.SchoolIds}
              onChange={(e) => ChangeSchool(e.target.value)}
              selectoption={SelectSchool}
            />
          )}
        </div>
      </div>
      {SCPTrends?.[0].assessmentDate ? (
        <Line options={options} data={data} />
      ) : (
        <div className="ErrorMessage">{SCPTrends}</div>
      )}
    </>
  );
};
export default SchoolTrends;
